var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[_c('h2',[_vm._v(_vm._s(_vm.port.name))]),_vm._v(" "),_c('a',{on:{"click":_vm.openPort}},[_vm._v("Open port!")])])}
var staticRenderFns = []

export { render, staticRenderFns }